import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, FieldArray, reduxForm, change } from "redux-form";
import AppWrapper from "../../Common/AppWrapper/index.jsx";
import { MutationDetectionIdentifier } from "./MutationDetectionIdentifier.jsx";
import { MutationDetectionSequence } from "./MutationDetectionSequence.jsx";
import { MutationDetectionForm } from "./MutationDetectionForm";
import MutationDetectionDescription from "./MutationDetection-Description.jsx";
import * as assayActions from "../../../actions/assays.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import _ from "underscore";

import "../AssayCreate.scss";

const styles = (theme) => ({
  progress: {
    marginLeft: theme.spacing(2),
  },
});

export class MutationDetectionComponent extends React.Component {
  static propTypes = {
    formObj: PropTypes.object,
    handleSubmit: PropTypes.func,
    pristine: PropTypes.bool,
    actions: PropTypes.object,
  };

  componentWillUnmount() {
    const { actions } = this.props;
    actions.clearMessage();
  }
  onSubmit = (values, dispatch) => {
    return dispatch(assayActions.processGetNewAssays(values));
  };

  render() {
    const {
      formObj,
      classes,
      handleSubmit,
      pristine,
      submitting,
      validatedAssayDetails,
      actions
    } = this.props;

    const btnSubmitClass = classNames({
      "btn-submit float-right": !submitting,
      "btn-submit float-right btn-submitting": submitting,
    });

    return (
      <div id="mutationdetection-form">
        <div className="row target-by">
                <div className="col ">
                  <strong>Enter Target by:&nbsp;</strong>
                  <div className="form-check form-check-inline">
                    <Field
                      className="form-check-input"
                      component="input"
                      type="radio"
                      name="targetby"
                      value="identifier"
                      onChange ={()=>actions.clearValidationMessages()}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="inlineCheckbox1"
                    >
                      Identifier
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <Field
                      className="form-check-input"
                      component="input"
                      type="radio"
                      name="targetby"
                      value="sequence"
                      onChange ={()=>actions.clearValidationMessages()}

                    />
                    <label
                      className="form-check-label"
                      htmlFor="inlineCheckbox2"
                    >
                      Sequence
                    </label>
                  </div>
                </div>
              </div>
        <FieldArray
          name="mutationDetectionForm"
          custom={this.props}
          component={MutationDetectionForm}
        />
        <div className="row">
          <div className="col">
            <button
              type="button"
              className={btnSubmitClass}
              disabled={
                (pristine || submitting) && _.isEmpty(validatedAssayDetails)
              }
              onClick={handleSubmit(this.onSubmit.bind(this))}
            >
              {!submitting ? "SUBMIT" : "SUBMITTING"}
              {submitting && (
                <CircularProgress
                  className={classes.progress}
                  size={20}
                  thickness={4}
                />
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const epochDate = new Date().getTime();

const stateToProps = (state) => ({
  formObj: state.form["frmMutationDetection"],
  validatedAssayDetails:
    (state.assays &&
      state.assays.validatedAssayDetails &&
      state.assays.validatedAssayDetails.data) ||
    {},
  initialValues: {
    applicationType: "MutationDetection",
    targetby: "identifier",
    mutationDetectionForm: [
      {
        mutationdetectionidentifier: {
          identifier: "",
          fluorophores: "FAM/HEX",
          assayFormat: "SingleTube",
          created_at: epochDate,
          assayType: "Mutation",
          uuid: "",
        },

        mutationdetectionsequence: {
          assayTargetName: "",
          genome: "Home sapiens",
          fluorophores: "FAM/HEX",
          created_at: epochDate,
          assayType: "Mutation",
        },
      },
    ],
  },
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

const onSubmit = (values, dispatch) => {
  dispatch(assayActions.processGetNewAssays(values));
};

MutationDetectionComponent = reduxForm({
  form: "frmMutationDetection",
  enableReinitialize: true,
})(MutationDetectionComponent);

MutationDetectionComponent = withStyles(styles)(MutationDetectionComponent);

MutationDetectionComponent = connect(
  stateToProps,
  dispatchToProps
)(MutationDetectionComponent);

const MutationDetection = () => {
  return (
    <AppWrapper
      id="mutationdetection"
      pageTitle="Mutation Detection"
      pageKeywords="Mutation Detection, design engine, custom assays"
      pageDescription=" Mutation detection assays can be designed instantly for over 4 million mutations, listed in the COSMIC database, on Bio-Rad’s Digital Assay Site."
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="hero">
          <h2 className="h4">ASSAY DESIGN ENGINE</h2>
          <h1>Mutation Detection</h1>
        </div>
        <MutationDetectionComponent />
        <MutationDetectionDescription />
      </div>
    </AppWrapper>
  );
};

export default MutationDetection;
